import { createTheme as muiCreateTheme } from "@mui/material/styles";

export default class Theme {
  static computedStyle = getComputedStyle(document.documentElement);

  muiTheme: any;
  breakpoints: any;

  constructor(muiTheme: any) {
    this.muiTheme = muiTheme;
    this.breakpoints = muiTheme.breakpoints;
  }

  isBreakpointDown(breakpoint: any) {
    return window.matchMedia(
      this.muiTheme.breakpoints.down(breakpoint).replace("@media ", "")
    ).matches;
  }

  isBreakpointUp(breakpoint: any) {
    return window.matchMedia(
      this.muiTheme.breakpoints.up(breakpoint).replace("@media ", "")
    ).matches;
  }

  getCurrentBreakpoint() {
    const deviceWidth = window.innerWidth;

    let currentBreakpoint = null;
    (Object as any).entries(this.breakpoints.values).forEach((b: any) => {
      if (deviceWidth >= b[1]) currentBreakpoint = b;
    });

    return currentBreakpoint;
  }

  static getStyleVar(varName: any) {
    return Theme.computedStyle.getPropertyValue(varName).trim();
  }

  static createTheme() {
    return new Theme(
      muiCreateTheme({
        name: "v2",
        typography: {
          fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        },
        palette: {
          primary: {
            light: "#0000FF",
            main: Theme.getStyleVar("--neon-blue-nb-400"),
            dark: "#000000",
          },
          secondary: {
            light: "#ff0000",
            main: Theme.getStyleVar("--neon-blue-nb-400"),
            dark: "#ff0000",
          },
          error: {
            main: Theme.getStyleVar("--torch-red-tr-500"),
          },
        },
        breakpoints: {
          values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1920,
          },
        },
      } as any)
    );
  }
}
